import { RefObject, useEffect } from 'react';

export function useOutsideClick(ref: RefObject<HTMLElement | null>, handler: () => void): void {
  useEffect(() => {
    const listener = (event: MouseEvent): void => {
      const element = ref.current;
      if (!element) {
        return;
      }

      const { target } = event;
      if (target instanceof Element) {
        if (element.contains(target) || !target.isConnected) {
          return;
        }
      }

      handler();
    };

    window.addEventListener('click', listener, { passive: true });
    return () => window.removeEventListener('click', listener);
  }, [ref, handler]);
}
